import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import { Link as LinkBase } from "react-router-dom";
import { reverse } from "lodash";
import { styleFunctions } from "./style-utilities";
import {
  Facebook,
  Twitter,
  Google,
  Linkedin,
  Mail,
  Phone
} from "grommet-icons";
import { SideBar } from "./Components/SideBar/SideBar";
import {
  Avatar as AvatarBase,
  Button as ButtonBase,
  Checkbox as CheckboxBase,
  Chip as ChipBase,
  ChipSet as ChipSetBase,
  CollapsibleList as CollapsibleListBase,
  Elevation as ElevationBase,
  Fab as FabBase,
  FormField as FormFieldBase,
  Icon as IconBase,
  IconButton as IconButtonBase,
  List as ListBase,
  ListDivider as ListDividerBase,
  ListGroup as ListGroupBase,
  ListItem as ListItemBase,
  ListItemGraphic as ListItemGraphicBase,
  ListItemMeta as ListItemMetaBase,
  ListItemText as ListItemTextBase,
  ListItemPrimaryText as ListItemPrimaryTextBase,
  ListItemSecondaryText as ListItemSecondaryTextBase,
  Menu as MenuBase,
  MenuItem,
  MenuSurface as MenuSurfaceBase,
  MenuSurfaceAnchor as MenuSurfaceAnchorBase,
  Radio as RadioBase,
  SimpleDialog as SimpleDialogBase,
  SimpleListItem as SimpleListItemBase,
  SimpleMenu as SimpleMenuBase,
  SimpleMenuSurface as SimpleMenuSurfaceBase,
  Switch as SwitchBase,
  Tab as TabBase,
  TabBar as TabBarBase,
  TextField as TextFieldBase,
  ThemeProvider,
  TopAppBar as TopAppBarBase,
  TopAppBarActionItem,
  TopAppBarFixedAdjust,
  TopAppBarNavigationIcon,
  TopAppBarRow as TopAppBarRowBase,
  TopAppBarSection as TopAppBarSectionBase,
  TopAppBarTitle,
  Typography as TypographyBase
} from "rmwc";
//Theme
const COLORS = {
  primary: "#244f7a",
  primaryDark: "#00274e",
  primaryLight: "#567ba9",
  secondary: "#bdbdbd",
  secondaryDark: "#8d8d8d",
  secondaryLight: "#efefef",
  error: "#b00020",
  background: "#efefef",
  surface: "#fff",
  primaryBg: "#244f7a",
  secondaryBg: "#efefef",
  textPrimaryOnBackground: "#244f7a",
  textSecondaryOnBackground: "#244f7a",
  textHintOnBackground: "#244f7a",
  textDisabledOnBackground: "#244f7a",
  textIconOnBackground: "#244f7a",
  textPrimaryOnLight: "#244f7a",
  textSecondaryOnLight: "#244f7a",
  textHintOnLight: "#244f7a",
  textDisabledOnLight: "#244f7a",
  textIconOnLight: "#244f7a",
  onPrimary: "#fff",
  onSecondary: "#244f7a",
  onError: "#244f7a",
  textPrimaryOnDark: "#fff",
  textSecondaryOnDark: "#fff",
  textHintOnDark: "#fff",
  textDisabledOnDark: "#fff",
  textIconOnDark: "#fff"
};

const SCALES = {
  majorSecond: [1.802, 1.602, 1.424, 1.266, 1.125, 1],
  minorThird: [2.488, 2.074, 1.728, 1.44, 1.2, 1],
  majorThird: [3.052, 2.441, 1.953, 1.563, 1.25, 1],
  perfectFourth: [4.209, 3.157, 2.369, 1.777, 1.333, 1],
  augmentedFourth: [5.653, 3.998, 2.827, 1.999, 1.414, 1]
};

export const materialThemeProviderOptions = {
  ...COLORS
};
export const theme = {
  colors: {
    ...COLORS
  },
  fontSizes: [13, 18, 24, 32, 43, 57, 108]
};
export const grommetTheme = {
  global: {
    colors: {
      brand: "#244f7a"
    }
  },
  accordion: {
    heading: { level: "3" },
    icons: {
      color: "dark-1"
    }
  }
};
export const Page = styled.section`
  ${styleFunctions}

  &:hover {
    ${props => props.hover}
  }
`;
Page.defaultProps = {
  display: "flex",
  flexDirection: "column"
};
export const Section = styled.section`
  ${styleFunctions}
`;
Section.defaultProps = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-around",
  position: "relative",
  minHeight: "38.2vh"
};

export const PageContentWrapWithSideBar = ({
  aboutText,
  aboutTitle,
  children,
  ...rest
}) => (
  <Box display="flex" width={1} {...rest}>
    <Section width={[1, null, 4 / 5]}>{children}</Section>
    <SideBar
      aboutText={aboutText}
      aboutTitle={aboutTitle}
      width={[1 / 5]}
      display={["none", null, "initial"]}
    />
  </Box>
);
export const Box = styled.div`
  ${styleFunctions}
`;

export const Button = styled(ButtonBase)`
  ${styleFunctions}
`;
Button.defaultProps = {
  borderRadius: "0px",
  dense: false
};
export const Icon = styled(IconBase)`
  ${styleFunctions}
`;
export const IconButton = styled(IconButtonBase)`
  ${styleFunctions}
`;

export const Fab = styled(FabBase)`
  ${styleFunctions}
`;

export const Link = styled(LinkBase)`
  ${styleFunctions}
  text-decoration:none !important:
  color:${COLORS.secondary};
`;

export const Heading = styled.h1`
  ${styleFunctions}
  font-family: 'Cormorant', serif;
  font-variant: small-caps !important;
  font-weight: bold;
  line-height: 1;
`;
Heading.defaultProps = {
  fontSize: 6,
  mb: "15px"
};
export const SubHeading = styled.h2`
  ${styleFunctions}
  font-family: ${({ fontFamily }) =>
    fontFamily === "sans" ? "'Lato', sans-serif;" : "'Cormorant', serif;"};
  font-variant: small-caps !important;
  font-weight: bold;
  line-height: 1;
`;
SubHeading.defaultProps = {
  fontSize: 4,
  mb: "15px"
};

export const Title = styled.h3`
  ${styleFunctions}
  font-family: 'Cormorant', serif;
  font-variant: small-caps !important;
  font-weight: bold;
  text-align: center;
  line-height: 1;
`;
Title.defaultProps = {
  fontSize: 4,
  mb: "15px"
};
export const SubTitle = styled.h4`
  ${styleFunctions}
  font-family: 'Cormorant', serif;
  color:${COLORS.secondaryDark}
  text-transform:uppercase;
  font-weight:bold;
  line-height: 2.618;
`;
SubTitle.defaultProps = {
  fontSize: 3,
  mb: "15px"
};
export const Text = styled.p`
  ${styleFunctions}
  font-family: 'Lato', sans-serif;
  &:hover {
    ${props => props.hover}
  }
`;
Text.defaultProps = {
  fontSize: 1,
  mb: "15px",
  lineHeight: 1.618
};

export const Caption = styled.p`
  ${styleFunctions}
  line-height: 1.618;
`;
Caption.defaultProps = {
  fontSize: 0
};
export const Form = styled.form`
  ${styleFunctions}
`;
export const List = styled(ListBase)`
  ${styleFunctions}
`;
export const ListItem = styled(ListItemBase)`
  ${styleFunctions}
`;
export const ListItemText = styled(ListItemTextBase)`
  ${styleFunctions}
`;
export const ListItemPrimaryText = styled(ListItemPrimaryTextBase)`
  ${styleFunctions}
`;
export const ListItemSecondaryText = styled(ListItemSecondaryTextBase)`
  ${styleFunctions}
`;
export const ListGroup = styled(ListGroupBase)`
  ${styleFunctions}
`;
export const ListItemGraphic = styled(ListItemGraphicBase)`
  ${styleFunctions}
`;
export const ListItemMeta = styled(ListItemMetaBase)`
  ${styleFunctions}
`;
export const ListDivider = styled(ListDividerBase)`
  ${styleFunctions}
`;
export const CollapsibleList = styled(CollapsibleListBase)`
  ${styleFunctions}
`;
export const SimpleListItem = styled(SimpleListItemBase)`
  ${styleFunctions}
`;

export const Menu = styled(MenuBase)`
  border-radius: 0px;
`;
export const SimpleDialog = styled(SimpleDialogBase)``;
export const TopAppBar = styled(TopAppBarBase)`
  ${styleFunctions}
  padding: 0px;
`;
export const TopAppBarRow = styled(TopAppBarRowBase)`
  ${styleFunctions}
  padding: 0px;
`;
export const TopAppBarSection = styled(TopAppBarSectionBase)`
  ${styleFunctions}
  justify-content: ${({ justifyContent }) => justifyContent};
  padding: 0px;
  nav, section, button, div{
    height:100% !important;
  }
`;
export const MenuSurfaceAnchor = styled(MenuSurfaceAnchorBase)`
  ${styleFunctions}
`;
export const MenuSurface = styled(MenuSurfaceBase)`
  ${styleFunctions}
`;

export const TabBar = styled(TabBarBase)`
  ${styleFunctions}
`;

export const Tab = styled(TabBase)`
  ${styleFunctions}
  .mdc-tab__text-label {
    color: white;
  }
`;

export const SimpleMenu = styled(SimpleMenuBase)`
  ${styleFunctions}
`;
export const SimpleMenuSurface = styled(SimpleMenuSurfaceBase)`
  ${styleFunctions}
`;
export const Image = styled.img`
  ${styleFunctions}
`;

export const Avatar = styled(AvatarBase)`
  ${styleFunctions}
`;
export const TextField = styled(TextFieldBase)`
  ${styleFunctions}
  div > div {
    border-radius: 0px !important;
  }
`;
export const FormField = styled(FormFieldBase)`
  ${styleFunctions}
`;

export const Elevation = styled(ElevationBase)`
  ${styleFunctions}
`;
export const Chip = styled(ChipBase)`
  ${styleFunctions}
`;
export const ChipSet = styled(ChipSetBase)`
  ${styleFunctions}
`;
export const Switch = styled(SwitchBase)`
  ${styleFunctions}
`;
export const Checkbox = styled(CheckboxBase)`
  ${styleFunctions}
`;
export const Radio = styled(RadioBase)`
  ${styleFunctions}
`;
export const ImageBox = ({
  bgImage,
  useFilter,
  children,
  imageBackgroundSize,
  bg,
  filter,
  blend,
  ...rest
}) => {
  return (
    <Box
      backgroundImage={bgImage ? `url(${bgImage})` : ""}
      backgroundSize={imageBackgroundSize || "cover"}
      backgroundRepeat="no-repeat"
      backgroundPosition="50% 33%"
      position="relative"
      display="flex"
      justifyContent="center"
      alignItems="center"
      {...rest}
    >
      {useFilter && (
        <Box
          bg={bg || "primary"}
          mixBlendMode={blend || "hard-light"}
          height="100%"
          width="100%"
          filter={filter || "saturate(.8)"}
          position="absolute"
          top="0"
          left="0"
        />
      )}
      {children}
    </Box>
  );
};
export const BlogCard = ({ title, description, image, ...rest }) => {
  return (
    <ImageBox
      useFilter="true"
      bg="primary"
      blend="color"
      width={["85%"]}
      mx={[0, null, null, 3]}
      my={3}
      height={200}
      bgImage={image}
      boxShadow="inset 0px -40px 20px 0px rgba(34,45,56, .9)"
      {...rest}
    >
      <Box
        position="absolute"
        height="100%"
        display="flex"
        flexWrap="wrap"
        bg="rgba(34,45,55,.2)"
        alignContent="flex-end"
      >
        <Heading px={3} width={1} color="white" fontSize={3}>
          {title}
        </Heading>
        <Text px={3} mb={0} width={1} color="white">
          A Blog About:
        </Text>
        <Text px={3} fontSize={0} color="white">
          {description}
        </Text>
      </Box>
    </ImageBox>
  );
};
export const HeroBlurb = ({
  text,
  buttonText,
  heading,
  path,
  color,
  ...rest
}) => {
  return (
    <Box maxWidth={900} py={5} zIndex={2} {...rest}>
      <Heading textAlign="center" color={color} fontSize={80}>
        {heading}
      </Heading>
      <Text
        fontSize={2}
        textTransform="uppercase"
        letterSpacing="3px"
        textAlign="center"
        color={color}
      >
        {text}
      </Text>
      {path && (
        <Box my={3} display="flex" justifyContent="center">
          <Button
            label={buttonText || "Submit"}
            raised
            tag={Link}
            to={path || "/"}
          />
        </Box>
      )}
    </Box>
  );
};
export const Blurb = ({
  text,
  subtitle,
  buttonText,
  heading,
  path,
  color,
  ...rest
}) => {
  return (
    <Box maxWidth={900} py={4} zIndex={2} {...rest}>
      <SubHeading textAlign="center" color={color}>
        {heading}
      </SubHeading>

      <Text px={3} mb={0} color={color}>
        {text}
      </Text>
      {path && (
        <Box my={3} display="flex" justifyContent="center">
          <Button
            label={buttonText || "Learn More"}
            raised
            tag={Link}
            to={path || "/"}
          />
        </Box>
      )}
    </Box>
  );
};
export const MainMenu = ({ menuOpen, routes }) => {
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      <TopAppBar fixed>
        <ThemeProvider options={{ primary: "white", onSurface: "white" }} wrap>
          <TopAppBarRow>
            <TopAppBarSection>
              <Button tag={LinkBase} height="100%" to="/">
                <Title fontSize={2} pl={3} mb={0}>
                  Egerton McAfee
                </Title>
              </Button>
            </TopAppBarSection>
            <TopAppBarSection alignEnd>
              <TabBar display={["none", null, "block"]}>
                {routes &&
                  routes.map(
                    r =>
                      r.showInMenu && (
                        <Link
                          width="100%"
                          mx="auto"
                          to={r.path}
                          style={{ textDecoration: "none" }}
                        >
                          <Tab width="100%" label={r.name} />
                        </Link>
                      )
                  )}
              </TabBar>

              <MainMenuDropdown
                display={["block", null, "none"]}
                open={open}
                setOpen={setOpen}
                routes={routes}
              />
            </TopAppBarSection>
          </TopAppBarRow>
        </ThemeProvider>
      </TopAppBar>
      <TopAppBarFixedAdjust />
    </Fragment>
  );
};
export const SocialIcons = ({ size, ...rest }) => {
  return (
    <Box display="flex" justifyContent="center" width={1}>
      <Box mx={1} my={2}>
        <Facebook size={size || "small"} />
      </Box>
      <Box mx={1} my={2}>
        <Twitter size={size || "small"} />
      </Box>
      <Box mx={1} my={2}>
        <Google size={size || "small"} />
      </Box>
      <Box mx={1} my={2}>
        <Linkedin mx={1} my={2} size={size || "small"} />
      </Box>
      <Box mx={1} my={2}>
        <Mail mx={1} my={2} size={size || "small"} />
      </Box>
      <Box mx={1} my={2}>
        <Phone mx={1} my={2} size={size || "small"} />
      </Box>
    </Box>
  );
};
export const MainMenuDropdown = ({
  routes,
  open,
  children,
  setOpen,
  ...rest
}) => {
  return (
    <MenuSurfaceAnchor height="100%" {...rest}>
      <MenuSurface
        open={open}
        onClose={evt => setOpen(false)}
        height={300}
        width={1}
        borderRadius={0}
        bg="secondary"
      >
        {routes &&
          routes.map(r => r.showInMenu && <MenuItem>{r.name}</MenuItem>)}
      </MenuSurface>
      <MainMenuLink
        trailingIcon="keyboard_arrow_down"
        onClick={() => setOpen(!open)}
      />
    </MenuSurfaceAnchor>
  );
};

const MainMenuLink = ({ label, path, ...rest }) => (
  <Button
    label={label || "Menu Item"}
    theme={["onPrimary"]}
    tag={path ? Link : "button"}
    to={path || "/"}
    height="100%"
    borderRadius="0px"
    {...rest}
  />
);
export const ContactForm = props => {
  return (
    <Box>
      <Form
        display="flex"
        px={3}
        flexWrap="wrap"
        justifyContent="space-between"
      >
        <FormField
          width={1}
          my={3}
          display="flex"
          justifyContent="space-between"
        >
          <TextField width="45%" outlined placeholder="Name" />
          <TextField outlined width="45%" placeholder="Email" />
        </FormField>
        <TextField
          width={1}
          my={2}
          outlined
          placeholder="Phone Number"
          width={1}
        />
        <TextField width={1} my={2} textarea outlined placeholder="Message" />
        <Checkbox my={2} label="Would you like to get more information?" />
        <Button my={2} raised label="submit" />
      </Form>
    </Box>
  );
};
